import { Overlay } from 'trading-vue-js';

export default {
    name: 'ATRp',
    mixins: [Overlay],
    methods: {
        meta_info() {
            return {
                author: 'StdSquad',
                version: '1.0.0',
                desc: 'Average True Range, %',
                preset: {
                    name: 'ATR $percentage % $length',
                    side: 'offchart',
                    settings: {
                        lineWidth: 0.75,
                        color: '#f44336',
                    },
                },
            };
        },
        use_for() {
            return ['ATRp'];
        },
        calc() {
            return {
                props: {
                    length: { def: 15, text: 'Length' },
                    applyto: { def: `close`, text: 'Apply to' },
                    percentage: { def: 100, text: 'Percentage' },
                },
                conf: { renderer: 'Spline' },
                update: `                    
                    if(applyto === 'open'){
                        return percentage * atr(length)[0] / open[0]                        
                    }else if(applyto === 'high'){
                        return percentage * atr(length)[0] / high[0]                                             
                    }else if(applyto === 'low'){
                        return percentage * atr(length)[0] / low[0]                         
                    }else if(applyto === 'hl2'){
                        return percentage * atr(length)[0] / ((high[0] + low[0]) / 2)
                    }else{
                        return percentage * atr(length)[0] / close[0]     
                    }
                    
                `,
            };
        },
    },
};
